import { request } from './request';

// 平台助手 (AI 使用答疑, 2026-10-14, doc/平台助手/设计-20261014.md):
// 依据使用指引回答"平台怎么用"; 二期 (2026-10-14) 可只读查询本人有权限的已发布数据 (不含人员信息); 记录只有本人可读.

export interface AssistantStatus {
    enabled: boolean;
    /** 不可用原因 (人读; 如 AI 未启用 / 当天预算用完) */
    reason?: string;
}

export type AssistantJobStatus = 'running' | 'ok' | 'error';
export type AssistantFeedback = 'none' | 'up' | 'down';

export interface AssistantJob {
    jobId: string;
    threadId: string;
    question: string;
    status: AssistantJobStatus;
    /** running 时是已生成的部分 */
    answer: string;
    error?: string;
    feedback: AssistantFeedback;
    createdAt: number;
    /** 生成耗时 (完成后才有) */
    elapsedMs: number;
    /** 生成中正在查询的数据 (中文名, 如"材料列表"); 空 = 没在查 */
    querying?: string;
}

export interface AssistantAskReq {
    question: string;
    threadId?: string;
    /** 当前页面的路由模板 (不含路径参数) 与菜单名 —— 只用来让回答贴合页面, 不传页面内容 */
    route?: string;
    routeName?: string;
}

export function getAssistantStatus(): Promise<AssistantStatus> {
    return request<AssistantStatus>('/v1/assistant/status');
}

export function askAssistant(body: AssistantAskReq): Promise<AssistantJob> {
    return request<AssistantJob>('/v1/assistant/ask', { method: 'POST', body });
}

export function getAssistantJob(jobId: string): Promise<AssistantJob> {
    return request<AssistantJob>(
        `/v1/assistant/jobs/${encodeURIComponent(jobId)}`,
    );
}

export function sendAssistantFeedback(body: {
    jobId: string;
    helpful: boolean;
    note?: string;
}): Promise<null> {
    return request<null>('/v1/assistant/feedback', { method: 'POST', body });
}

// ---- 助手反馈 (管理员): 看大家问了什么、哪些回答没帮上, 用来补使用指引 ----

export interface AssistantAdminStats {
    days: number;
    questions: number;
    askers: number;
    up: number;
    down: number;
    errors: number;
    costUsd: number;
    avgElapsedMs: number;
    routes: { routeName: string; count: number; down: number }[];
    topQuestions: { question: string; count: number; down: number }[];
}

export interface AssistantAdminChat {
    id: number;
    operatorEmail: string;
    routeName: string;
    route: string;
    question: string;
    answer: string;
    status: AssistantJobStatus;
    error: string;
    feedback: AssistantFeedback;
    feedbackNote: string;
    elapsedMs: number;
    costUsd: number;
    createdAt: number;
}

/** 明细筛选: down 没帮上 / up 有帮助 / none 未评价 / error 失败 / all 全部 */
export type AssistantChatFilter = 'down' | 'up' | 'none' | 'error' | 'all';

export function getAssistantAdminStats(
    days: number,
): Promise<AssistantAdminStats> {
    return request<AssistantAdminStats>('/v1/assistant/admin/stats', {
        query: { days },
    });
}

export function listAssistantAdminChats(q: {
    days: number;
    filter: AssistantChatFilter;
    keyword?: string;
    page: number;
    pageSize: number;
}): Promise<{
    list: AssistantAdminChat[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
}> {
    return request('/v1/assistant/admin/chats', { query: q });
}
